<template>
  <div class="container">
      <div class="content">
        <detail ref="detail" :load-timeline="$route.query.reapply !== '1'" @detail="onDetail" ></detail>
        <div class="footer" :class="[isCollapsed?'footer-collapsed':'']">
          <!-- {{detail}} -->
            <!-- status 1:正在处理 2:撤销 3:驳回 4:已结束 -->
            <div class="footer-btn" v-show="detail.status" >
              <el-button type="info" plain  @click="returnToApprovals()">返回</el-button>
              <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName && detail.businessName !== 'noticeDetail'" plain  @click="lookAccount()">查看账号</el-button>
              <el-button type="primary" v-if="!$root.desktopWorkbench && detail.businessName === 'noticeDetail'" plain  @click="lookAnnouncement()">查看</el-button>
              <el-button type="warning" @click="onReapply">再次编辑</el-button>
              <el-button type="danger"  v-if="detail.canCancel" @click="onRevoke" :loading="btnRevokeLoading">撤销审批</el-button>
              <el-button type="primary" @click="onComment" :loading="btnCommentLoading">评论</el-button>
              <!-- <el-button type="primary"  v-if="detail.status==2" @click="onSubmit"  :loading="btnSubmitLoading">提交审批</el-button> -->
              <el-button type="primary" @click="getPdf('export')" :loading="btnExport">导出</el-button>
              <el-button type="primary" @click="getPdf('print')" :loading="btnPrint">打印</el-button>
            </div>
        </div>
      </div>
      <!-- 浮层 评论-->
      <popComment ref="popComment" @ok="setComment"></popComment>
      <popDialog ref="popDialog" @ok="okDialog"></popDialog>
  </div>
</template>
<script>

import mixinsDetail from '@/pages/officeApproval/approvalList/mixins/detail.js'
import popDialog from "@/pages/officeApproval/approvalList/components/popDialog.vue";
export default {
  name: 'myApprovalDetail',
  mixins: [mixinsDetail],
  components: {
    popDialog
  },
  data() {
      return {
          btnLoading: false,
          btnRevokeLoading:false,
          btnSubmitLoading:false,
          reapplyStarted:false,
      }
  },
  created() {
  },

  mounted() {

  },
  methods: {
    onDetail(detail) {
      this.setDetail(detail)
      if (!this.reapplyStarted && this.$route.query.reapply === '1' && detail.status) {
        this.reapplyStarted = true
        const query = Object.assign({}, this.$route.query)
        delete query.reapply
        this.$router.replace({ path: this.$route.path, query }).then(
          () => this.$nextTick(() => this.onReapply()),
          () => this.$nextTick(() => this.onReapply())
        )
      }
    },
    // 使用当前审批的数据重新发起一份新审批，原审批保持不变
    onReapply() {
      const templateId = this.$refs.detail.prepareReapply();
      if (templateId) {
        localStorage.setItem('selectedMenuIndex', '/officeApproval/list')
        this.$router.push({
          name: "sendApproval",
          query: {
            id: templateId,
            type: 'edit'
          }
        });
      } else {
        this.$message.warning('当前审批模板不可用')
      }
    },
    okDialog(type){
      // console.log('okDialog',type)
      if(type==='revoke'){
        this.setRevoke()
      }else if(type==='submit'){
        this.setSubmit()
      }
    },
    // 撤销审批
    onRevoke() {
      this.$refs.popDialog.show('revoke','是否确认撤销审批？');
    },
    setRevoke(){
      const postData = {
        processInstanceId: this.$route.query.id,
      };
      this.btnRevokeLoading = true;
      // return false;
      this.$api.workflowRevoke(postData).then((res) => {
        if (res.code === 0) {
          this.$message.success("撤销成功");
          this.$refs.detail.fetchData()
        }
      }).finally(()=>{
        this.btnRevokeLoading = false
      })
    },
    // 提交审批 重新提交
    onSubmit() {
      this.$refs.popDialog.show('submit','是否确认提交审批？');
    },
    setSubmit(){
      console.error('没接口')
      // this.btnSubmitLoading=true;
      // setTimeout(()=>{
      //   this.btnSubmitLoading=false;
      //   this.$router.push({
      //     name: "approvalMyList",
      //   });
      // },1000)
    }
    // 重置表单
    // resetForm() {
    //   this.$refs.processDetailForm.resetForm();
    // },
    // // 发起审批
    // submitForm() {
    //   const formData = this.$refs.processDetailForm.getFormData();
    //   const form = this.$refs.processDetailForm.getForm();
    //   const processUser = this.$refs.processDetailForm.getProcessUser();
    //   const strUserInfo = sessionStorage.getItem("userInfo");
    //   this.btnLoading = true;
    //   const postData = {
    //     processDefinitionId: form.processDefinitionId,
    //     formData,
    //     processUsers: processUser,
    //     startUserInfo: JSON.parse(strUserInfo),
    //   }
    //   // console.log("postData", postData);
    //   // return false;
    //   this.$refs.processDetailForm.validate((valid) => {
    //     if (valid) {
    //       this.$api.workflowStart(postData).then((res) => {
    //         // console.log("startProcess", res);
    //         if (res.code === 0) {
    //           this.$message.success("提交成功");
    //           this.$router.push({
    //             name: "approvalMyList",
    //           });
    //         }else if(res.message){
    //           this.$message.error(res.message);
    //         }
    //         this.btnLoading = false;
    //       }).catch(err=>{
    //         this.btnLoading = false;
    //       });
    //     } else {
    //       this.$message.warning("请完善表单");
    //       this.btnLoading = false;
    //     }
    //   });
    // },
  }
}
</script>

<style scoped lang="scss" src="./mixins/detailLayout.scss"></style>
